module.exports = __webpack_public_path__ + "img/n1@2x.d6ff6411.png";